module.exports = __webpack_public_path__ + "img/QI.646f15bd.png";